import React from 'react';
import { useUser } from '@clerk/clerk-react';
import { useAdminApproval } from './AdminApprovalProvider';
import { Box, Typography, List, ListItem, Button, Paper, Alert, Divider } from '@mui/material';

export const AdminDashboard: React.FC = () => {
  const { user } = useUser();
  const { pendingUsers, approveUser, rejectUser } = useAdminApproval();

  // Check if the current user is an admin
  const isAdmin = user?.publicMetadata?.role === 'admin';

  if (!isAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          <Typography variant="h6">Access Denied</Typography>
          <Typography>You do not have permission to access this page.</Typography>
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="info" sx={{ mb: 2 }}>
        <Typography variant="h6">
          Admin Dashboard - Welcome, {user?.firstName || 'Admin'}! 👑
        </Typography>
        <Typography variant="body2">
          You have administrative privileges. Manage user approvals below and use the travel assistant.
        </Typography>
      </Alert>

      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Pending User Approvals
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <List>
          {pendingUsers.map((pendingUser) => (
            <ListItem
              key={pendingUser.id}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #eee',
                py: 2,
              }}
            >
              <Box>
                <Typography variant="subtitle1">{pendingUser.email}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {pendingUser.createdAt}
                </Typography>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => approveUser(pendingUser.id)}
                  sx={{ mr: 1 }}
                >
                  Approve
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => rejectUser(pendingUser.id)}
                >
                  Reject
                </Button>
              </Box>
            </ListItem>
          ))}
          {pendingUsers.length === 0 && (
            <ListItem>
              <Typography color="text.secondary">No pending approvals</Typography>
            </ListItem>
          )}
        </List>
      </Paper>
    </Box>
  );
}; 